/*eslint-disable*/
import $Cookies from 'js-cookie';
import store from '@/common/store/';
import format from 'timestamp-format';

// 老虎机使用jpg图片的平台
const jpgArr = ['mg', 'dt', 'jdb'];
let lang = function () {
  return $Cookies.get('lang')
}

const CryptoJS = require('crypto-js'); //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412'); //十六位十六进制数作为密钥偏移量
//解密方法
export function Decrypt(word) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

//加密方法
export function Encrypt(word) {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString().toUpperCase();
}

// 存款链接
export function depositUrl(params) {
  if (params.payType !== 'IB' && params.payType !== 'BK') {
    // 选择平台的支付方式
    window.open(
      `${params.payDomain}?payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}`
    )
  } else if (params.payType === 'IB') {
    // 选择IB
    window.open(
      `${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}`
    )
  } else if (params.payType === 'BK') {
    window.open(`${params.payDomain}?payType=${params.payType}&uuId=${params.userId}`)
  }
}
// 新存款链接
export function newDepositUrl(params) {
  let domain = window.location.origin
  if (params.payType !== 'IB' && params.payType !== 'BK') {
    // 选择平台的支付方式

    // if(!params.amount){
    //   window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }else{
    //   window.open(`${params.payDomain}?payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }

    window.open(
      `${params.payDomain}?payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}&remark=${params.remark}`
    )
  } else if (params.payType === 'IB') {
    // 选择IB
    // if(!params.amount){
    //   window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }else{
    //   window.open(`${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}`)
    // }

    window.open(
      `${params.payDomain}?bankCode=${params.bankCode}&payConfigId=${params.payConfigId}&amount=${params.amount}&payType=${params.payType}&uuId=${params.userId}&domain=${domain}&remark=${params.remark}`
    )
  } else if (params.payType === 'BK') {

    window.open(`${params.payDomain}?payType=${params.payType}&uuId=${params.userId}&domain=${domain}&lang=${lang()}`)
  }
}
// 新支付存款链接(BK类型)
export function newDepositBankUrl(payType, UUID, payDomain) {
  let domain = window.location.origin
  window.open(`${payDomain}?payType=${payType}&uuId=${UUID}&domain=${domain}&lang=${lang()}`)
}
// build24
export function ForenewDepositUrl(params) {
  let domain = window.location.origin
  window.open(`${params.payDomain}?payType=${params.payType}&uuId=${params.userId}&domain=${domain}&lang=${lang()}`)
}
// 银行存款链接
export function bankurl(params) {
  window.location.href = `${params.payDomain}?payType=${params.payType}&uuId=${params.userId}`
}
// 随机字符串
export function randomRange(min, max) {
  var returnStr = "",
    range = (max ? Math.round(Math.random() * (max - min)) + min : min),
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
      'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
      'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];
  for (var i = 0; i < range; i++) {
    var index = Math.round(Math.random() * (arr.length - 1));
    returnStr += arr[index];
  }
  return returnStr;
}
export function getInfo(level, proportion, limit) {
  let levels = level.split(',');
  let proportions = proportion.split(',');
  let limits = limit.split(',');
  let arr = [];
  levels.forEach((item, index) => {
    let obj = {};
    obj['level'] = levels[index];
    obj['scale'] = proportions[index];
    obj['max'] = limits[index];
    arr.push(obj)
  });
  return arr
}
export function isCollect(gameList, mySlot) {
  gameList.forEach((gamesItem) => {
    mySlot.forEach((myItem) => {
      if (gamesItem.id === myItem.id) {
        gamesItem['collect'] = true;
      }
    })
  });
  return gameList
}

export function slotJoint(picLink, isLogin, UUID, resp) { // 收藏
  let src = isLogin ? '/game/forward' : '/game/guest/forward';
  let data = resp.data.data.list;
  let gameType = 1;
  if (data === null || data === []) {
    data = [];
    return data
  } else {

    data.forEach((item) => {
      // if(item.platformCode==='HB'){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '_zh-CN.png';
      // }else if(jpgArr.includes(item.platformCode.toLowerCase())){
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.jpg';
      // }else {
      //   item['picLink'] = picLink + 'game/' + item.platformCode + '/' + item.gameId + '.png';
      // }
      item['picLink'] = picLink + (item.h5Img ? item.h5Img : item.pcImg)
      item['href'] =
        `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang()}`
      item['collect'] = true;
    });
    return data
  }
}


// 首页平台拼接
// goGame(item,isLogin,UUID) {
//   let src = isLogin ? '/game/forward' : '/game/guest/forward' ;
//   let href =  `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}`;
//   if (isLogin) {
//     window.open(href);
//     return true
//   } else {
//
//     // goGameTip()
//     return false
//   }
// },
// goGameTip() {
//
// },


export function safetyIndex(obj) {
  let number = 4;
  let count = 0;
  let sum = 100;
  let unit = 25;
  if (obj.emailValid) {
    count += unit;
    number--
  }
  if (obj.mobileValid) {
    count += unit;
    number--
  }
  if (obj.nameValid) {
    count += unit;
    number--
  }
  if (obj.withdrawPasswordValid) {
    count += unit;
    number--
  }
  if (count === 0) {
    count = 20
  }
  if (count === 100) {
    count -= 1
  }
  count = (count / sum) * 100;
  return {
    count: count,
    number: number
  }
}
export function getBrowserInfo() {
  let agent = navigator.userAgent.toLowerCase();
  let regStr_ie = /msie [\d.]+;/gi;
  let regStr_ff = /firefox\/[\d.]+/gi
  let regStr_chrome = /chrome\/[\d.]+/gi;
  let regStr_saf = /safari\/[\d.]+/gi;
  let regStr_uc = /uc\/[\d.]+/gi
  let regStr_QQ = /qq\/[\d.]+/gi
  let regStr_baidu = /baidu\/[\d.]+/gi
  let isIE = agent.indexOf("compatible") > -1 && agent.indexOf("msie" > -1); //判断是否IE<11浏览器
  let isEdge = agent.indexOf("edge") > -1 && !isIE; //判断是否IE的Edge浏览器
  let isIE11 = agent.indexOf('trident') > -1 && agent.indexOf("rv:11.0") > -1;
  if (isIE) {
    var reIE = new RegExp("msie (\\d+\\.\\d+);");
    reIE.test(agent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return "IE/7";
    } else if (fIEVersion == 8) {
      return "IE/8";
    } else if (fIEVersion == 9) {
      return "IE/9";
    } else if (fIEVersion == 10) {
      return "IE/10";
    }
  } //isIE end
  if (isIE11) {
    return "IE/11";
  }
  //firefox
  if (agent.indexOf("firefox") > 0) {
    return agent.match(regStr_ff);
  }
  //Safari
  if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
    return agent.match(regStr_saf);
  }
  //Chrome
  if (agent.indexOf("chrome") > 0) {
    return agent.match(regStr_chrome);
  }
  // uc
  if (agent.indexOf("UCBrowser") > 0) {
    return agent.match(regStr_uc);
  }
  //qq
  if (agent.indexOf("QQ") > 0) {
    return agent.match(regStr_QQ);
  }
  // baidu
  if (agent.indexOf("baidu") > 0) {
    return agent.match(regStr_baidu);
  }
  return ['unknow']
}



// 获取系统及版本
export function getOsInfo() {
  var userAgent = navigator.userAgent.toLowerCase();
  var name = 'Unknown';
  var version = "Unknown";
  if (userAgent.indexOf("win") > -1) {
    name = "Windows";
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("windows nt 5.2") > -1) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
      version = "Windows 7";
    } else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows nt 10.0") > -1) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if (userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if (userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if (userAgent.indexOf("x11") > -1 || userAgent.indexOf("unix") > -1 || userAgent.indexOf("sunname") > -1 ||
    userAgent.indexOf("bsd") > -1) {
    name = "Unix";
  } else if (userAgent.indexOf("linux") > -1) {
    if (userAgent.indexOf("android") > -1) {
      name = "Android"
    } else {
      name = "Linux";
    }

  } else {
    name = "Unknown";
  }
  var os = new Object();
  os.name = name;
  os.version = version;
  return os;
  //document.write("系统：" + os.name + "版本:" + os.name)
}

// 首页导航分类
export const nav_list_arr = [
  // 1.真人 2. 体育 3. 老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
  // '/game/liveCasino','/game/sports','/game/slotMachine','/game/chess','/game/catchFish','/game/lottery','/signIn','/discounts',
  // '/mine',

  // 1.真人 2. 体育 3. 老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
  // gameType:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
  '/gameIndex/2', '/gameIndex/3', '/game/slotMachine', '/gameIndex/6', '/gameIndex/5', '/gameIndex/4', '/signIn',
  '/discounts',
  '/mine',
]

// 进入老虎机游戏
export function goSlotGame(item, isLogin, UUID , type = 0) {
  let gameType = item.gameType || 1
  let src = isLogin ? '/game/forward' : '/game/guest/forward';
  let href =
    `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang()}`;
  // if (isLogin) {
  //   window.open(href);
  //   return false;
  // } else {
  //   return true
  // }
  if (type === 0) window.open(href)
  if (type === 1) return href
}

// 试玩老虎机游戏
export function trySlotGame(item) {
  let gameType = 1;
  let src = '/game/guest/forward';
  let href =
    `/api${src}?linkType=1&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang()}`;
  window.open(href);
}
// 进入真人娱乐，体育等有游戏
export function goGame(item, isLogin, UUID, type = 0) {
  let src = isLogin ? '/game/forward' : '/game/guest/forward';
  let href =
    `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang()}`;
  if (type === 0) window.open(href)
  if (type === 1) return href
}
//进入棋牌具体游戏
export function goSpecificGame(item, isLogin, UUID) {
  if ((!item.hasOwnProperty('gameType') || item.gameType === '6') && item.hasOwnProperty('gameId')) {
    // 具体游戏，老虎机/棋牌等
    let gameType = item.gameType ? item.gameType : 6;
    let src = isLogin ? '/game/forward' : '/game/guest/forward';
    let href =
      `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.fullName}&gameType=${gameType}&gameCode=${item.gameId}&lang=${lang()}`;
    window.open(href)
  } else {
    let src = isLogin ? '/game/forward' : '/game/guest/forward';
    let href =
      `/api${src}?UUID=${UUID}&linkType=1&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang()}`;
    window.open(href)
  }
}
export function tryGame(item) {
  let src = '/game/guest/forward';
  let href =
    `/api${src}?linkType=1&platformCode=${item.platformCode}&platformKey=${item.platformKey}&gameType=${item.gameType}&lang=${lang()}`;
  window.open(href)
}
// 调用App方法
export function emitAppMethods(methodsName, parmars) {
  if (/android/i.test(navigator.userAgent)) {
    // todo : android
    if (!window.android) return
    try {
      // window.android[methodsName](parmars);
      // // window.android.methodsName(parmars);
      // // window.android.goOffer()
      // // window.android.JS_APP_WealthCenter()
      // window.android.JS_APP_GoBack()
      // window.android.JS_APP_GoBack()
      // window.android.nativeMethod(methodsName)
      // window.android.nativeMethod()
      switch (methodsName) {
        case 'JS_APP_GoBack':
          window.android.JS_APP_GoBack()
          break;
        case 'JS_APP_HOME':
          window.android.JS_APP_HOME()
          break;
        case 'JS_APP_WealthCenter':
          window.android.JS_APP_WealthCenter()
          break;
        case 'JS_APP_ActivityList':
          window.android.JS_APP_ActivityList()
          break;
        case 'JS_APP_Withdrawal':
          window.android.JS_APP_Withdrawal()
          break;
        case 'JS_APP_Deposit':
          window.android.JS_APP_Deposit()
          break;
        case 'JS_APP_Registered':
          window.android.JS_APP_Registered()
          break;
        case 'JS_APP_Login':
          window.android.JS_APP_Login()
          break;
        case 'JS_APP_UserMange':
          window.android.JS_APP_UserMange()
          break;
        case 'JS_APP_EuropeEvent':
          window.android.JS_APP_EuropeEvent()
          break;
      }
    } catch (err) {
      console.log(err)
    }
  } else if (/ipad|iphone|iPod|iOS|mac/i.test(navigator.userAgent)) {
    if (!window.webkit || !window.webkit.messageHandlers) return
    let message = {
      'method': methodsName,
      'param': parmars,
    }
    try {
      window.webkit.messageHandlers.jsOpenSwiftFunc.postMessage(message);
    } catch (err) {
      console.log(err)
    }

  }
}
//app或h5调用的方法

export function testMethods(methodsName, parmars) {
  methodsName(parmars)
}
// 挂件跳转处理
export function goHref(url) {
  if (!url) return;

  if (url.indexOf('.qq.com') > -1 || url.indexOf('.meiqia.com') > -1 || url.indexOf('chat.livechatvalue.com') > -1 ||
    url.indexOf('live800') > -1) {
    window.open(url, '', );
  } else if (url.indexOf('tencent://') === 0) {
    window.location.href = url;
  } else if (url.startsWith('/')) {
    // return url.split('#')[1];
    return url
  } else {
    window.open(url)
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/common/utils/common.js